const SecureFieldFlights = [
  'PXEnableSecureFieldAddCreditCard',
  'PXEnableSecureFieldUpdateCreditCard',
  'PXEnableSecureFieldReplaceCreditCard',
  'PXEnableSecureFieldSearchTransaction',
  'PXEnableSecureFieldCvvChallenge',
  'PXEnableSecureFieldIndia3DSChallenge',
];

export function getChallengeAdditionalHeaders(
  pidlEnvironment: string,
  isPidlSecureFieldsIsolationAdoptionEnabled: boolean
): Record<string, string> {
  const additionalHeaders: Record<string, string> = {};

  if (pidlEnvironment === 'int') {
    additionalHeaders['x-ms-test'] = '{"scenarios": "px-service-psd2-e2e-emulator", "contact": "test"}';
  }

  if (isPidlSecureFieldsIsolationAdoptionEnabled) {
    additionalHeaders['x-ms-flight'] = SecureFieldFlights.join(',');
  }

  return additionalHeaders;
}
